import { type SubmitFunction } from '@remix-run/react'

interface HandleSubmitCompletedFormParams {
	submit: SubmitFunction
	CSRFToken: string
}

export function handleCompletedForm({
	CSRFToken,
	submit,
}: HandleSubmitCompletedFormParams) {
	const formData = new FormData()
	formData.append('formHasBeenCompleted', 'true')
	formData.append('csrf', CSRFToken)

	submit(formData, { method: 'post' })
}
